<script setup>
defineProps({
  icon: {
    type: String,
    required: true,
  },

  label: {
    type: String,
    default: null,
  },

  fixedWidth: {
    type: Boolean,
    default: true,
  },
});
</script>

<template>
  <span
    class="inline-flex shrink-0 items-center justify-center"
    :class="{ 'w-[1.25em]': fixedWidth }"
    :aria-label="label || undefined"
    :aria-hidden="label ? undefined : 'true'"
    :role="label ? 'img' : undefined"
  >
    <i :class="icon" />
  </span>
</template>
